// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2RxQC","left":"InfoRow_left__WSyA6"};